import Cookie from "js-cookie";
import { Navigate } from "react-router-dom";

export const Logout = () => {
  Cookie.remove("ut_admin");
  return <Navigate to="/login" />;
};
